<ngx-datatable 
    #table 
    class='material striped' 
    [loadingIndicator]="loadingIndicator"
    [columns]="columns" 
    [columnMode]="'force'" 
    [headerHeight]="50"                      
    [footerHeight]="50"
    [rowHeight]="'auto'"
    [limit]="params.per_page"        
    [rows]='rows'
    (sort)="onSort($event)">


    <ngx-datatable-column name="Cliente" prop="cliente" [sortable]="true" [width]="300" >
        <ng-template let-rowIndex="rowIndex" let-cliente="value" ngx-datatable-cell-template style="width: 200px;">
            {{cliente.numero_xp}} - {{cliente.nome}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Estrategia" prop="estrategia" [sortable]="true">
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            {{row.estrategia?.nome}}
        </ng-template>
    </ngx-datatable-column>
    
    <ngx-datatable-column name="Ativo" prop="sigla_ativo" [sortable]="true">
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            {{row.ativo.sigla}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Qtd.Custodia Prosper" prop="qtd" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            {{row.qtd_custodia_prosper}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Qtd.Custodia Corretora" prop="qtd" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            {{row.qtd_custodia_corretora}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Ação" prop="qtd" [sortable]="false">
        <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <button mat-icon-button matTooltip="Salvar" (click)="save(row.id)">
                <mat-icon aria-label="Salvar">save</mat-icon>
            </button>

            <button mat-icon-button color="warn" matTooltip="Excluir" (click)="delete(row.id)">
                <mat-icon aria-label="Excluir">delete</mat-icon>
            </button>
        </ng-template>
    </ngx-datatable-column>

</ngx-datatable>

<div style="padding: 5px 10px">
    <mat-paginator 
        #paginator 
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent($event)">
    </mat-paginator>
</div>